import flatpickr from 'flatpickr' // flatpickr
import 'flatpickr/dist/l10n/ja' // flatpickr日本語化
/*
<script src="<?php echo T_URL; ?>/js/form.min.js?v=<?php echo filemtime(T_PATH . '/js/form.min.js'); ?>"></script>
*/

/*
 ######  ######## ##       ########  ######  ########
##       ##       ##       ##       ##          ##
 ######  ######   ##       ######   ##          ##
      ## ##       ##       ##       ##          ##
 ######  ######## ######## ########  ######     ##
*/
// // 空のセレクトボックスに文を入れる
// const blankSelect = document.querySelectorAll('.mw_wp_form select option[value=""]')
// if (blankSelect[0]) {
//   for (let index = 0; index < blankSelect.length; index++) {
//     blankSelect[index].innerText = '選択してください'
//   }
// }

/*
######## #### ########
    ##    ##  ##     ##
   ##     ##  ########
  ##      ##  ##
######## #### ##
*/
/*
郵便番号から住所を検索する
入力欄のグループ数、name属性がどのように設定されても対応できる冗長な形式
*/
/* global AjaxZip3 */

/*
<input type="text" name="" class="js-zip--zip1">
<input type="text" name="" class="js-zip--zip1">
<button type="button" class="js-zip" data-zip="zip1">
住所検索
</button>

<input type="text" name="" class="js-zip--zip1">
<input type="text" name="" class="js-zip--zip1">
<input type="text" name="" class="js-zip--zip1">
*/

window.addEventListener('click', function (e) {
  const item = e.target.closest('.js-zip')
  if (!item) {
    return
  }

  const target = item.dataset.zip

  // 住所グループを取得する
  const inputList = document.querySelectorAll('input.js-zip--' + target + ',select.js-zip--' + target)

  console.log({ inputList })

  // 各入力欄のname属性を収集する
  const nameList = []
  for (const input of inputList) {
    nameList.push(input.name) // 配列の末尾に追加
  }

  console.log({ nameList })

  // 各入出力先をnameから指定
  // 郵便番号上3桁もしくは7桁, 郵便番号下4桁（不要なら空欄）, 都道府県の出力先, 市区町村～町域の出力先
  AjaxZip3.zip2addr(nameList[0], nameList[1], nameList[2], nameList[3], nameList[4])

  setTimeout(() => {
    window.textCount() // 文字数カウント実行

    // 市区町村のselectに独自コードが入っている関係でAjaxZIPが機能しないのでinputから流す
    const convertInput = document.querySelector('input.js-zip--' + target + '-convert')
    if (convertInput) {
      const convertSelect = document.querySelector('select.js-zip--' + target + '-convert')
      const convertOptionList = convertSelect.querySelectorAll('option')
      for (const option of convertOptionList) {
        if (option.innerText === convertInput.value) {
          option.setAttribute('selected', '')
          convertSelect.setAttribute('placeholder', option.innerText)
        } else {
          option.removeAttribute('selected')
        }
      }
      convertSelect.classList.remove('complete')
      convertSelect.nextElementSibling.parentNode.removeChild(convertSelect.nextElementSibling)
      unwrap(convertSelect.parentNode) // 親を外す
    }

    const selectList = document.querySelectorAll('select.js-zip--' + target)
    if (selectList[0]) {
      for (const select of selectList) {
        // セレクトボックスを独自に変更している場合は解除
        select.classList.remove('complete')
        select.nextElementSibling.parentNode.removeChild(select.nextElementSibling)
        const optionList = select.querySelectorAll('option')

        for (const option of optionList) {
          if (option.value === select.value) {
            console.log(option.innerText)

            option.setAttribute('selected', '')
            select.setAttribute('placeholder', option.innerText)
          } else {
            option.removeAttribute('selected')
          }
        }

        unwrap(select.parentNode) // 親を外す
      }

      window.selectSetup() // セレクトボックスの初期化
    }
  }, 500)
  // 指定した要素を削除して子要素を残す
  // unwrap(document.querySelector('.hoge'))
  function unwrap(target) {
    while (target.firstChild) {
      target.parentNode.insertBefore(target.firstChild, target)
    }
    target.remove()
  }
})

/*
 ######   #######  ##    ## ##     ## ######## ########  ########
##       ##     ## ####  ## ##     ## ##       ##     ##    ##
##       ##     ## ## ## ## ##     ## ######   ########     ##
##       ##     ## ##  ####  ##   ##  ##       ##   ##      ##
 ######   #######  ##    ##    ###    ######## ##     ##    ##
*/
// 特定のテキストフォームを適した形式に変える

// // 電話番号→tel
// let convertInput = document.querySelector('[type="text"][name="tel"]')
// if (convertInput) {
//   convertInput.setAttribute('type', 'tel')
// }

// // 郵便番号→number
// // スピンボタンが付いてしまうので以下のようなCSSで消す必要がある
// /*
// input[type="number"]::-webkit-outer-spin-button,
// input[type="number"]::-webkit-inner-spin-button {
//   -webkit-appearance: none;
//   margin: 0;
// }
// input[type="number"] {
//   -moz-appearance: textfield;
// }
// */
// convertInput = document.querySelector('[type="text"][name="zip1"]')
// if (convertInput) {
//   convertInput.setAttribute('type', 'number')
// }
// convertInput = document.querySelector('[type="text"][name="zip2"]')
// if (convertInput) {
//   convertInput.setAttribute('type', 'number')
// }
// // メール→email
// convertInput = document.querySelector('[type="text"][name="mail"]')
// if (convertInput) {
//   convertInput.setAttribute('type', 'email')
// }

/*
########          ########  ####  ######  ##    ## ######## ########
##     ##         ##     ##  ##  ##    ## ##   ##  ##       ##     ##
##     ##         ##     ##  ##  ##       ##  ##   ##       ##     ##
##     ## ####### ########   ##  ##       #####    ######   ########
##     ##         ##         ##  ##       ##  ##   ##       ##   ##
##     ##         ##         ##  ##    ## ##   ##  ##       ##    ##
########          ##        ####  ######  ##    ## ######## ##     ##
*/
/*
flatpickrによるデートピッカー
本コード冒頭のインポートと_js.scssのCSSインポートを有効化して使用

例：
<input type="text" name="date1" class="js-date">
<input type="text" name="date2" class="js-date">
*/

// // ブラウザバック時に入力値を戻すためにpageshowで動作させる
// window.addEventListener('pageshow', function () {
//   const datepicker = flatpickr('.js-date', {
//     // 指定クラスにデートピッカーを付ける
//     // minDate: new Date().fp_incr(1), // 最短設定日 n日後から
//     // maxDate: new Date().fp_incr(30), // 最長設定日 n日後まで
//     // mode: 'range', // 範囲で指定させる
//     locale: 'ja',
//     altFormat: 'Y/m/d',
//     dateFormat: 'Y/m/d',
//     disableMobile: true, // SP時にブラウザ標準の日付UIに切り替えない
//     // altFormat: 'Y/m/d H:i',
//     // dateFormat: 'Y/m/d H:i',
//     // enableTime: true, // 時間指定可能にする
//     // time_24hr: false, // 24h/AMPM形式
//     disable: [
//       // 選択禁止する日付　trueを返すと禁止
//       // function (date) {
//       //   // 指定番号の曜日と合致したら禁止　0:日曜～6:土曜
//       //   if (date.getDay() === 0) {
//       //     return true
//       //   }
//       // },
//     ],
//     onChange: function (selectedDates, dateStr, instance) {},
//   })

//   // デフォルトのflatpickrにはクリアボタンが無いのでカレンダー内に増設する
//   const datepickerList = document.querySelectorAll('.flatpickr-calendar')
//   for (let index = 0; index < datepickerList.length; index++) {
//     const element = datepickerList[index]
//     const datepickerBtn = document.createElement('button')
//     datepickerBtn.innerHTML = '×クリア' // 文言
//     datepickerBtn.setAttribute('type', 'button')
//     datepickerBtn.setAttribute('style', 'padding: 5px;color: #F67A79')
//     datepickerBtn.setAttribute('data-datepicker-clear', index)
//     datepickerBtn.addEventListener('click', function (e) {
//       if (Array.isArray(datepicker)) {
//         datepicker[this.dataset.datepickerClear].clear() // クリア処理
//         datepicker[this.dataset.datepickerClear].close() // カレンダーを閉じる
//       } else {
//         datepicker.clear() // クリア処理
//         datepicker.close() // カレンダーを閉じる
//       }
//     })
//     element.appendChild(datepickerBtn)
//   }
// })
